import React from 'react';
import axios from 'axios';
import {GET_COMMUNES, GET_EXPLOITATIONS, GET_QUARTIERS, GET_RUES, GET_VILLES} from "../../api/Api";

export default function useLocationData(type,filter){

    const [isLoading,setIsLoading] = React.useState(false);
    const [locations,setLocations] = React.useState([]);

    const url = React.useMemo(
        () => {
            switch (type){

                case 'villes':
                    return GET_VILLES
                case 'quartiers':
                    return GET_QUARTIERS;
                case 'rues':
                    return GET_RUES;
                case 'communes':
                    return GET_COMMUNES

            }
        }
    );


    React.useEffect(
        () => {

            setIsLoading(true)

            axios
                .get(
                    url,
                    {
                        params: filter
                    }
                ).then(
                ({data}) => {

                     setLocations(data);

                }

            ).finally(
                ()=>{
                    setIsLoading(false);
                }
            )

        }, []
    );

    return [isLoading,locations]
}